import styled from 'styled-components';

import { Spacing } from 'theme/theme';

export const StackHolder = styled.div<{
  $direction: 'row' | 'column';
  $spacing?: Spacing;
}>`
  display: flex;
  flex-direction: ${({ $direction }) => $direction};
  align-items: stretch;
  justify-content: flex-start;
  gap: ${({ $spacing }) => $spacing || 0};
`;
